import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfilePublications,
  ProfileContactSection,
} from './StaffProfileTemplate';

const JelleWoutersProfile = () => {
  const person = {
    id: 'jelle-j-p-wouters',
    name: 'Jelle J. P. Wouters',
    honorific: 'Prof',
    title: 'Highland Fellow',
    affiliation: 'Professor of Anthropology & Director of Research & Development, Royal Thimphu College, Bhutan',
    image: 'https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/2skjiezj_Jelle%20J.P.%20Wouters.jpg',
    email: null,
    category: 'Fellows & Visiting Scholars',
    testid: 'jelle-wouters-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      {/* Intellectual Biography */}
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            'Jelle J. P. Wouters is a Professor of Anthropology and Director of Research and Development at Royal Thimphu College in Bhutan. His scholarship is situated at the intersections of political anthropology, environmental humanities, political ecology, and the anthropology of the Asian Highlands.',
            'His research has a particular geographical focus on Naga lands, Bhutan, and the wider Asian Highlands. He is dedicated to understanding political life, insurgency, state formation, indigeneity, environmental change, and how communities navigate broad regional transformations.',
            'His work combines ethnographic engagement with theoretical and historical questions concerning power, politics, environment, and social change. He is committed to ethnographically grounded scholarship that prioritizes the political, environmental, and social worlds of highland communities.',
          ]}
        />
      </ProfileSection>

      {/* Research Foci & Areas of Work */}
      <ProfileSection title="Research Foci & Areas of Work">
        <ProfileBullets
          items={[
            'Political anthropology and vernacular politics (political life, state-society relations, political imagination, everyday political practice in South and Southeast Asia)',
            'Naga societies and Northeast India (insurgency, political transformation, identity, sovereignty, historical and contemporary politics of Naga lands)',
            'Environmental humanities and climate change (social, political, and cultural dimensions of environmental transformation and climate change in the Asian Highlands)',
            'Asian Highlands (highland societies, their political, ecological, and social worlds, with engagement across Naga lands, Bhutan, and the wider Himalayan and upland region)',
            'Anthropology of the state, conflict, and political change (how communities encounter, negotiate, resist, and reshape formal political institutions and processes of state formation)',
          ]}
        />
      </ProfileSection>

      {/* Highland Institute Projects */}
      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            'Professor Wouters brings his expertise in political anthropology and environmental humanities to collaborative research initiatives at The Highland Institute. His long-term engagement with Naga lands and the wider Asian Highlands, combined with his focus on state formation, insurgency, and environmental change, complements the Institute\'s mission to advance research on highland societies and their transformations.',
          ]}
        />
      </ProfileSection>

      {/* Education */}
      <ProfileSection title="Education">
        <ProfileParagraphs
          items={[
            'Professor Wouters studied anthropology in Amsterdam, Oxford, and Shillong.',
          ]}
        />
      </ProfileSection>

      {/* Selected Publications & Knowledge Outputs */}
      <ProfileSection title="Selected Publications & Knowledge Outputs">
        <ProfileParagraphs
          items={[
            'He is the author, co-author, and editor of 12 books, including:',
          ]}
        />
        <ProfilePublications
          items={[
            {
              year: '2023',
              citation: (
                <>
                  <em>The Routledge Companion to Northeast India</em> (co-edited with T. B. Subba), Routledge.
                </>
              ),
            },
            {
              year: '2022',
              citation: (
                <>
                  <em>Vernacular Politics in Northeast India</em>.
                </>
              ),
            },
            {
              year: '2022',
              citation: (
                <>
                  <em>Nagapolis</em>.
                </>
              ),
            },
            {
              year: '2022',
              citation: (
                <>
                  <em>Subaltern Studies 2.0: Being Against the Capitalocene</em>.
                </>
              ),
            },
            {
              year: '2018',
              citation: (
                <>
                  <em>In the Shadows of Naga Insurgency</em>.
                </>
              ),
            },
          ]}
        />
        <ProfileParagraphs
          items={[
            'He has also contributed to edited academic volumes and collaborative scholarship.',
          ]}
        />
      </ProfileSection>

      {/* Public Engagement, Teaching & Community Work */}
      <ProfileSection title="Public Engagement, Teaching & Community Work">
        <ProfileParagraphs
          items={[
            'Professor Wouters has taught at Sikkim Central University (India) and the University of Tübingen (Germany). His teaching and supervision encompass political anthropology, environmental humanities, political and social theory, and the study of societies and political formations in the Asian Highlands.',
            'In his role as Director of Research & Development at Royal Thimphu College, he is involved in strengthening research and academic development at the institution.',
          ]}
        />
      </ProfileSection>

      {/* Contact & Scholarly Infrastructure */}
      <ProfileContactSection
        role="Professor of Anthropology & Director of Research & Development, Royal Thimphu College, Bhutan; Highland Fellow"
        testidPrefix="jelle"
        scholarlyProfiles={[
          { label: 'Academia.edu', url: 'https://rub-ovc.academia.edu/JelleWouters', testid: 'jelle-academia-link' },
        ]}
      />
    </StaffProfileTemplate>
  );
};

export default JelleWoutersProfile;
